var _slicedToArray = require("/home/runner/work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _createForOfIteratorHelper = require("/home/runner/work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");
var _classCallCheck = require("/home/runner/work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/home/runner/work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _get = require("/home/runner/work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");
var _getPrototypeOf = require("/home/runner/work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/home/runner/work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var _createSuper = require("/home/runner/work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");
var OrangeChartAbstractXY = require('./orange-chart-abstract-x-y');
var OrangeChartAbstractGrid = /*#__PURE__*/function (_OrangeChartAbstractX) {
  "use strict";

  _inherits(OrangeChartAbstractGrid, _OrangeChartAbstractX);
  var _super = _createSuper(OrangeChartAbstractGrid);
  function OrangeChartAbstractGrid() {
    _classCallCheck(this, OrangeChartAbstractGrid);
    return _super.apply(this, arguments);
  }
  _createClass(OrangeChartAbstractGrid, [{
    key: "_get_basic_dimensions",
    value:
    /**
     * Basic dimensions of the chart
     *
     * @param {object} view
     * @return {{width:number, height:number}}
     * @protected
     */
    function _get_basic_dimensions(view) {
      var margin = view.hasOwnProperty('margin') ? view.margin : view.hasOwnProperty('width') ? view.width / (this._data.length - 1) : 10;
      var width = margin * (this._data.length - 1);
      var height = view.hasOwnProperty('height') ? view.height : 100;
      return {
        width: width,
        height: height
      };
    }

    /**
     * Renders chart's elements
     *
     * @abstract
     * @protected
     */
  }, {
    key: "_do_render_elements",
    value: function _do_render_elements() {
      throw new Error('_do_render_elements should be overridden');
    }

    /**
     * Renders chart
     *
     * @param {OrangeSVG} svg
     * @param {object} view
     * @param {number} x1
     * @param {number} y1
     * @param {number} x2
     * @param {number} y2
     * @protected
     */
  }, {
    key: "_do_render",
    value: function _do_render(svg, view, x1, y1, x2, y2) {
      _get(_getPrototypeOf(OrangeChartAbstractGrid.prototype), "_do_render", this).call(this, svg, view, x1, y1, x2, y2);
      var width = x2 - x1;
      var height = y2 - y1;
      var margin = width / (this._data.length - 1);
      var position_w, position_h, radius, min_radius, max_radius, base_radius, h_position_property;
      if (this._axes.hasOwnProperty('z')) {
        base_radius = view.hasOwnProperty('radius') ? view.radius : 2;
        min_radius = view.hasOwnProperty('min_radius') ? view.min_radius : base_radius;
        max_radius = view.hasOwnProperty('max_radius') ? view.max_radius : 10 * base_radius;
      }
      var x_scale = this._axes.x.scale;
      var y_scale = this._axes.y.scale;
      var z_scale = this._axes.z ? this._axes.z.scale : null;
      var elements;
      var _iterator = _createForOfIteratorHelper(this._source_mapping),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var line = _step.value;
          if (!line.hasOwnProperty('property')) {
            throw new Error('"property" should be defined for "line" in properties');
          }
          elements = [];
          for (var _i = 0, _Object$entries = Object.entries(this._data); _i < _Object$entries.length; _i++) {
            var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
              i = _Object$entries$_i[0],
              row = _Object$entries$_i[1];
            i = parseInt(i);
            position_w = this._axes.x.dynamic ? (row[this._axes.x.source] - x_scale.min) / (x_scale.max - x_scale.min) * width : margin * i;
            if (z_scale && this._axes.z.dynamic) {
              radius = (row[this._axes.z.source] - z_scale.min) / (z_scale.max - z_scale.min) * (max_radius - min_radius) + min_radius;
              h_position_property = this._axes.y.source;
            } else {
              h_position_property = line.property;
            }
            var h_value_v = row[h_position_property] - y_scale.min;
            var h_value_r = y_scale.max - y_scale.min;
            var h_value = this._axes.y._config.dynamic && this._axes.y._config.log ? h_value_v ? Math.log(h_value_v) / Math.log(h_value_r) : 0 : h_value_v / h_value_r;
            position_h = height - h_value * height;
            position_w += x1;
            position_h += y1;
            elements.push([position_w, position_h, radius || base_radius || null, row]);
          }
          this._do_render_elements(svg, elements, line.hasOwnProperty('color') ? line.color : null, line.property, view, {
            x1: x1,
            y1: y1,
            x2: x2,
            y2: y2
          });
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }], [{
    key: "chart_type_code",
    get:
    /**
     * Chart type
     *
     * @type {string}
     * @static
     */
    function get() {
      return 'lines';
    }

    /**
     * Returns allowed axes for the chart
     *
     * @type {string[]}
     * @static
     */
  }, {
    key: "allowed_axes",
    get: function get() {
      return ['x', 'y'];
    }
  }]);
  return OrangeChartAbstractGrid;
}(OrangeChartAbstractXY);
module.exports = OrangeChartAbstractGrid;